import { Component, Input, OnChanges } from '@angular/core';

import { SedsLoadersCoreModeOptions } from './enums/seds-loaders-mode-options.enum';
import { SedsLoadersCoreModeOptionsType } from './types/seds-loaders-mode-options.type';
import { SedsLoadersCoreTypeOptions } from './enums/seds-loaders-type-options.enum';
import { SedsLoadersCoreOptionsType } from './types/seds-loaders-type-options.type';
import { SedsSizeOptions } from '../../../shared/enums/seds-size-options.enum';
import { SedsSizeOptionsType } from '../../../shared/types/seds-size-options.type';

@Component({
    selector: 'seds-loaders-core',
    templateUrl: './seds-loaders-core.component.html',
    styleUrls: ['./seds-loaders-core.component.scss'],
    standalone: false
})
export class SedsLoadersCoreComponent implements OnChanges {
  @Input() current = 0;
  @Input() mode: SedsLoadersCoreModeOptionsType | SedsLoadersCoreModeOptions = SedsLoadersCoreModeOptions.INDETERMINATE;
  @Input() percentage = false;
  @Input() total = 0;
  @Input() type: SedsLoadersCoreOptionsType | SedsLoadersCoreTypeOptions = SedsLoadersCoreTypeOptions.PROGRESS_BAR;
  @Input() size: SedsSizeOptionsType | SedsSizeOptions = SedsSizeOptions.STANDARD;

  public resultPercentage?: number;

  ngOnChanges() {
    this.calculatePercentage(this.current, this.total);
  }

  private calculatePercentage(current: number, total: number): number {
    if (current > total) {
      throw new Error('Current value cannot be greater than the total value');
    }

    const percentage = parseFloat(((current / total) * 100).toFixed(2));
    this.resultPercentage = percentage;
    return percentage;
  }
}
